import { createPermission, getPermission } from "../firestore/Functions/permissionFunctions";
import { Roles } from "../firestore/Types/PermissionSchema";
import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

export const doCreateUserWithEmailAndPassword = async (email: string, password: string) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = async (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignUpWithEmailAndPassword = async (email: string, password: string) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  // sign in user
  doSignInWithEmailAndPassword(email, password);
  return result;
}

export const doSignInWithGoogleUser = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider);
  const permission = await getPermission();
  if (!permission) {
    await createPermission(Roles.User);
  }
};

export const doSignInWithGoogleTutor = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider);
  const permission = await getPermission();
  if (!permission) {
    await createPermission(Roles.Tutor);
  }
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email: string) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password: string) => {
  if (auth.currentUser) {
    return updatePassword(auth.currentUser, password);
  } else {
    throw new Error("No user is currently signed in.");
  }
};

export const doSendEmailVerification = () => {
  if (auth.currentUser) {
    return sendEmailVerification(auth.currentUser, {
      url: `${window.location.origin}/account`,
    });
  } else {
    throw new Error("No user is currently signed in.");
  }
};